/**
 * Hybrid Card Component
 * Automatically chooses between Tailwind and styled-components based on props.
 *
 * Routes to the styled-components path when a styled-system prop is present
 * (hasStyledProps), a BORDER-mixin prop is present (hasBorderProps), or the
 * component was extended with styled() (isStyledExtension). Otherwise renders
 * the Tailwind path (preferred - no runtime CSS-in-JS).
 */

import React from "react";
import {
  hasStyledProps,
  hasBorderProps,
  isStyledExtension,
} from "@sproutsocial/seeds-react-system-props";

import type { TypeCardProps } from "./CardTypes";
import CardStyled from "./CardStyled"; // Styled-components version
import { CardTailwind } from "./CardTailwind"; // Tailwind version

const CardHybrid = React.forwardRef<HTMLDivElement, TypeCardProps>(
  (props, ref) => {
    if (
      hasStyledProps(props) ||
      hasBorderProps(props) ||
      isStyledExtension(props)
    ) {
      return <CardStyled {...props} ref={ref} />;
    }

    // Use Tailwind version (preferred - better performance)
    return <CardTailwind {...props} ref={ref} />;
  }
);

CardHybrid.displayName = "Card";
export default CardHybrid;
